import { ApiError, callApi, callApiJson } from '../api';

export async function fetchIdentityProviders(): Promise<{ identityProviderId?: string | null }> {
  return callApiJson('/auth/fusionauth/identity-providers');
}

export async function exchangeCodeForTokens(params: {
  code: string;
  redirect_uri: string;
  client_id: string;
  grant_type: string;
  invite_code?: string | null;
}) {
  const response = await callApi(
    '/auth/fusionauth/token-proxy',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    // A failed login has no application session to expire. The callback offers recovery.
    { skip401Redirect: true },
  );
  if (response.status === 401) {
    throw new ApiError('Authentication failed. Please sign in again.', 401);
  }
}
